import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Admin credentials
    const adminUser = 'livetv24';
    const adminPass = 'youprodhan2026';

    if (username === adminUser && password === adminPass) {
      // Get today's date for the admin URL
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const adminPath = `/admin/${day}`;
      
      // Store admin session
      localStorage.setItem('streambd_admin', 'true');
      localStorage.setItem('streambd_admin_day', day);
      
      navigate(adminPath);
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div style={{
      paddingTop: '60px',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)'
    }}>
      <div style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: '16px',
        padding: '40px',
        width: '100%',
        maxWidth: '420px'
      }}>
        <div style={{
          fontFamily: "'Teko', sans-serif",
          fontSize: '32px',
          fontWeight: 700,
          color: 'var(--accent)',
          textAlign: 'center',
          marginBottom: '8px'
        }}>Admin Login</div>
        <div style={{
          textAlign: 'center',
          color: 'var(--muted)',
          fontSize: '13px',
          marginBottom: '28px'
        }}>Enter your credentials to access the dashboard</div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{
              fontSize: '12px',
              fontWeight: 600,
              color: 'var(--muted)',
              display: 'block',
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: '100%',
                background: 'var(--card)',
                border: '1px solid var(--border)',
                color: 'var(--text)',
                padding: '10px 12px',
                borderRadius: '8px',
                fontSize: '13px',
                outline: 'none',
                transition: '0.2s'
              }}
              placeholder="Enter username"
              required
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              fontSize: '12px',
              fontWeight: 600,
              color: 'var(--muted)',
              display: 'block',
              marginBottom: '6px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                background: 'var(--card)',
                border: '1px solid var(--border)',
                color: 'var(--text)',
                padding: '10px 12px',
                borderRadius: '8px',
                fontSize: '13px',
                outline: 'none',
                transition: '0.2s'
              }}
              placeholder="Enter password"
              required
            />
          </div>

          {error && (
            <div style={{
              color: 'var(--live)',
              fontSize: '13px',
              marginBottom: '16px',
              textAlign: 'center'
            }}>{error}</div>
          )}

          <button
            type="submit"
            style={{
              width: '100%',
              background: 'var(--accent)',
              color: '#fff',
              border: 'none',
              padding: '12px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: '0.2s'
            }}
          >
            🔐 Login
          </button>
        </form>

        <div style={{
          marginTop: '20px',
          textAlign: 'center',
          color: 'var(--muted)',
          fontSize: '12px'
        }}>
          <span>Demo credentials provided in the system</span>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;